import API from "../app/api";

export const fetchMetaService = async (pageSlug) => {
    try {
        const encodedSlug = btoa(pageSlug);
        const { data } = await API.get(`/meta?page_slug=${encodedSlug}`);

        if (!data?.success) {
            throw new Error(data?.message || "Failed Meta");
        }

        return data?.data || [];
    } catch (error) {
        // Handle axios error properly
        const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            "Something went wrong while fetching mega Menu";

        throw new Error(errorMessage);
    }
};